var Image = /** @class */ (function () {
    function Image(column) {
        this.column = column;
        this.setting = column.$el[0].querySelector('.ac-column-setting--image');
        if (!this.setting) {
            return;
        }
        this.field = this.setting.querySelector('.ac-setting-input select');
        this.initState();
        this.bindEvents();
    }
    Image.prototype.getValue = function () {
        return this.field.value;
    };
    Image.prototype.bindEvents = function () {
        var self = this;
        this.field.addEventListener('change', function (e) {
            self.initState();
        });
    };
    Image.prototype.initState = function () {
        if ('cpac-custom' === this.getValue()) {
            this.showSubsettings();
        }
        else {
            this.hideSubsettings();
        }
    };
    Image.prototype.hideSubsettings = function () {
        var subsetting = this.setting.querySelectorAll('.ac-column-setting');
        for (var i = 0; i < subsetting.length; ++i) {
            subsetting[i].style.display = 'none';
        }
    };
    Image.prototype.showSubsettings = function () {
        var subsetting = this.setting.querySelectorAll('.ac-column-setting');
        for (var i = 0; i < subsetting.length; ++i) {
            subsetting[i].style.display = 'table';
        }
    };
    Image.prototype.setValue = function (value) {
        this.field.value = value;
        this.trigger(this.field, 'change');
        return this;
    };
    Image.prototype.setWidth = function (width) {
        var field = this.setting.querySelector('.ac-column-setting [name*="image_size_w"]');
        field.value = width;
        this.trigger(field, 'change');
        return this;
    };
    Image.prototype.setHeight = function (height) {
        var field = this.setting.querySelector('.ac-column-setting [name*="image_size_h"]');
        field.value = height;
        this.trigger(field, 'change');
        return this;
    };
    Image.prototype.setSize = function (width, height) {
        this.setWidth(width);
        this.setHeight(height);
        return this;
    };
    Image.prototype.trigger = function (el, event) {
        el.dispatchEvent(new Event(event));
        return this;
    };
    return Image;
}());
var image = function (column) {
    column.settings.image = new Image(column);
};
export default image;
